import React from 'react';
import PropTypes from 'prop-types';
import { Button, Dropdown } from 'react-bootstrap';
import cx from 'classnames';
import { PUBLISH_ACTION } from '../constants/actions';
import style from './PageListActions.scss';
import { renderOverlay } from '.';

const propTypes = {
  page: PropTypes.object.isRequired,
  handleActionModal: PropTypes.func.isRequired,
  asTopMenuOpt: PropTypes.bool,
  singleBtn: PropTypes.bool,
};

const PublishAction = ({
  page, handleActionModal, asTopMenuOpt, singleBtn,
}) => {
  const { unpublishedChanges } = page;
  const onClick = unpublishedChanges ?
    handleActionModal({ actionName: PUBLISH_ACTION, currPage: page }) : () => {};

  return renderOverlay({
    authorized: unpublishedChanges,
    action: { message: 'This page does not have any unpublished changes.' },
    showLock: false,
    option: asTopMenuOpt ? (
      <span className={cx(style.topBtnWrapper, { [style.disabledBtnWrapper]: !unpublishedChanges })}>
        <Button
          onClick={onClick}
          className={cx(style.topBtn, { [style.singleBtn]: singleBtn, [style.disabledBtn]: !unpublishedChanges })}
        >
          Publish
        </Button>
      </span>
    ) : (
      <Dropdown.Item
        onClick={onClick}
        disabled={!unpublishedChanges}
        className={cx(style.actionMenuItem, { [style.disabledItem]: !unpublishedChanges })}
      >
        Publish
      </Dropdown.Item>
    ),
  });
};

PublishAction.propTypes = propTypes;

export default PublishAction;
